import React, { FunctionComponent, PropsWithChildren } from "react";
import SideNavbar from "./SideNavbar/SideNavbar";
import Header from "./Header";
import { SuspenseLayout } from "./SuspenseLayout";
import { Outlet, useLocation } from "react-router-dom";

export const LoggedInLayout: FunctionComponent<PropsWithChildren> = () => {
  const location = useLocation();

  return (
    <SuspenseLayout>
      <div className="flex h-screen w-screen bg-slate-100">
        <div className="flex-none grow-0 h-full ">
          <SideNavbar />
        </div>
        <div className={
          " h-screen flex flex-col mb-[20px] min-w-0 overflow-y-scroll grow p-5 pt-[0px]"
        }
        >
          <Header />
          <main className="flex grow flex-1 w-full min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
    </SuspenseLayout>
  );
}

export default LoggedInLayout;
